module.exports = __webpack_public_path__ + "static/media/closed-door.0c8032cc.jpg";